import { render, staticRenderFns } from "./productQrders.vue?vue&type=template&id=921a5d68&scoped=true&"
import script from "./productQrders.vue?vue&type=script&lang=js&"
export * from "./productQrders.vue?vue&type=script&lang=js&"
import style0 from "./productQrders.vue?vue&type=style&index=0&id=921a5d68&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "921a5d68",
  null
  
)

export default component.exports